import { createStore } from 'vuex'

// localStorage is read at boot, before anything can render. A malformed value -
// the string "undefined" is the usual culprit, from JSON.stringify(undefined) -
// used to throw here and leave a blank white page with no way out but clearing
// site data by hand. Treat unreadable state as "not logged in" instead.
function readJSON(key, fallback) {
  const raw = localStorage.getItem(key)
  if (raw === null || raw === '' || raw === 'undefined') return fallback

  try {
    const parsed = JSON.parse(raw)
    return parsed === null || parsed === undefined ? fallback : parsed
  } catch (e) {
    console.warn(`Discarding unreadable "${key}" in localStorage`, e)
    localStorage.removeItem(key)
    return fallback
  }
}

export default createStore({
  state: {
    asideVisible: false,
    sidebarVisible: true,
    sidebarUnfoldable: false,
    theme: 'default',
    isFilterModalOpen: false,
    isLoggedIn: !!localStorage.getItem("token"),
    isLog : !!localStorage.getItem("token"),
    baseURL : 'https://chatbot.animos.org/api/',
    // baseURL : 'http://localhost:4060/api/',
    token : localStorage.getItem("token"),
    user : readJSON("user", null),
    filters : readJSON("filters", {})
  },
  mutations: {
    SET_FILTERS(state, filters) {
      state.filters = filters;
      console.log(filters)
    },
    TOGGLE_FILTER_MODAL(state, status) {
      state.isFilterModalOpen = status;
    },
    toggleAside(state) {
      state.asideVisible = !state.asideVisible
      console.log("Toggle Aside : ");
      console.log(state)
    },
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
      console.log("Toggle Sidebar : ");
      console.log(state)
    },
    toggleTheme(state, payload) {
      state.theme = payload.value
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value;   
      console.log("Toggle Sidebar Visible : ");
      console.log(state)   
      console.log(payload) 
    },
    set (state, [variable, value]) {
      state[variable] = value
    },
    loginUser (state, payload) {
        state.isLoggedIn = true
        state.isLog = true
        state.token = payload.token;
        state.user = payload.user;
    },
    logoutUser (state) {
        state.isLoggedIn = false
        state.isLog = false
        state.token = null
        state.user = null
    }

  },
  actions: {
    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    toggleFilterModal({ commit }, status) {
      commit('TOGGLE_FILTER_MODAL', status);
    }
  },
  modules: {

  },
  getters: {
    getFilters: (state) => state.filters,
    isModalOpen: (state) => state.isFilterModalOpen
  }
})
